import { render, staticRenderFns } from "./ClientData.vue?vue&type=template&id=7faf58a0&scoped=true"
import script from "./ClientData.vue?vue&type=script&lang=js"
export * from "./ClientData.vue?vue&type=script&lang=js"
import style0 from "./ClientData.vue?vue&type=style&index=0&id=7faf58a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf58a0",
  null
  
)

export default component.exports